import { Props } from './types'
import styles from './styles.module.scss'
import { GeneralNotification } from 'ui/molecules/GeneralNotification'
import { BREAKPOINTS_KEYS, useDetectScreen } from 'hooks/useDetectScreen'

export const AuthLayout = ({ Form, WelcomeBlock }: Props) => {
  const screen = useDetectScreen()
  return (
    <div className={styles['container']}>
      {screen !== BREAKPOINTS_KEYS.MOBILE && (
        <div className={styles['container-left']}>{WelcomeBlock}</div>
      )}
      <div className={styles['container-right']}>{Form}</div>
      <div>
        <GeneralNotification top={40} right="40px" />
      </div>
    </div>
  )
}
